/**
 * 编辑器滑选高亮统一实现
 */

import $ from "jquery";

const HIGHLIGHT_CLASS = 'range-highlight'
const HIGHLIGHT_SELECTOR = `.${HIGHLIGHT_CLASS}`

/**
 * 清除高亮，返回清除区域被替换的节点
 * @returns replacedNodes
 */
export function clearHighlightSelection() {
  // 移除其他高亮
  const $highlights = $(HIGHLIGHT_SELECTOR)
  $highlights.removeClass(HIGHLIGHT_CLASS)
  return null
}

/**
 * 高亮当前滑选区域
 * @param selection 
 */
export function highlightSelection(selection) {
  // 移除其他高亮
  clearHighlightSelection()
  const range = selection.range
  let rangeStr = range.toString()
  if (range && rangeStr.length > 0) {
    // let $wrapper = $(`<span class="${HIGHLIGHT_CLASS}" style="background-color:#DCEAFE"></span>`)
    let startNode = range.startContainer
    let endNode = range.endContainer
    let startDIV = startNode.nodeName == "DIV" ? startNode : $(startNode).parents("div")[0]
    let endDIV = endNode.nodeName == "DIV" ? endNode : $(endNode).parents("div")[0]
    //第一段和最后一段是否滑选整段，滑选整段无需处理
    // let startDiff = false, endDiff = false;
    // let rangeStrList = rangeStr.slice('/n')
    // if (rangeStrList[0] != startDIV.textContent) {
    //   startDiff = true;
    // }
    // if (rangeStrList[rangeStrList.length - 1] != endDIV.textContent) {
    //   endDiff = true;
    // }
    if (startDIV != endDIV) {
      // let range2 = new Range()
      if ($(range.cloneContents()).find("div").length > 2) {
        highlightdiff(startDIV.nextSibling, 0, endDIV.previousSibling, endDIV.previousSibling.childNodes.length)
      }

      if (!startDIV.contains(endDIV)) {
        highlightdiff(startNode, range.startOffset, startDIV, startDIV.childNodes.length)
      } else {
        let node=$(startDIV).find("div")[0]
        highlightdiff(startNode, range.startOffset, node, 0)
      }
      highlightdiff(endDIV, 0, endNode, range.endOffset)
    } else {
      highlightdiff(startNode,range.startOffset,endNode,range.endOffset)
    }
  }
}
function highlightdiff(startNode, startOffset, endNode, endOffset) {
  let range2 = document.createRange()
  range2.setStart(startNode, startOffset)
  range2.setEnd(endNode, endOffset)
  let dom = range2.extractContents()
  highlightEle(dom)
  range2.insertNode(dom)
  range2.detach();
}
function highlightEle(el: any, spaceDIVList: any = []) {
  console.log('el', el.innerHTML);
  let childNodes = el.childNodes
  for (let i = 0; i < childNodes.length; i++) {
    console.log(i);

    let node = childNodes[i]
    switch (node.nodeName) {
      case "#text":
        if (node.textContent.length > 0) {
          var span = document.createElement('span');
          span.className = HIGHLIGHT_CLASS;
          var content = node.textContent || node.nodeValue;
          span.textContent = content;
          node.parentNode.replaceChild(span, node);
        }
        break
      case 'SPAN':
        if (node.textContent.trim().length > 0) {
          node.className = node.className ? node.className + ' ' + HIGHLIGHT_CLASS : HIGHLIGHT_CLASS;
        }
        break
      case 'DIV':
        if (node.textContent.trim().length > 0) {
          highlightEle(node, spaceDIVList)
        } else {
          if (node.childNodes.length == 0) {
            spaceDIVList.push(node)
          }
        }
    }

  }
}
function removeDIV(el: any) {

}
